var NATIVE_STATE = require('../state').native;
var jsbridge = require("@tencent/txmv-core/jsbridge");
var jsonp = require('@tencent/jsonp');
var Url = require('@tencent/url')
var localStorage = window.localStorage || {
  setItem: function () {
  },
  getItem: function () {
  }
};

//下载器各种状态
var DOWNLOADER_STATE = {
  'download_removed': NATIVE_STATE.CANCEL,
  'download_succ': NATIVE_STATE.DOWNLOADED,
  'downloading': NATIVE_STATE.DOWNLOADING,
  'download_fail': NATIVE_STATE.FAIL,
  'installing': NATIVE_STATE.INSTALLING,
  'install_succ': NATIVE_STATE.INSTALLED,
  'pause': NATIVE_STATE.PAUSE,
  'download_start': NATIVE_STATE.DOWNLOADING,
};

module.exports = function (native, _callback) {
  var callbacked = false;
  var callback = function () {
    if (callbacked) {
      return;
    }
    callbacked = true;
    _callback.apply(this, arguments);
  };

  jsbridge(function (suc) {
    if (suc) {
      build(native, callback);
      if (!native.package.wxDownloaderCallback) {
        WeixinJSBridge.on("wxdownload:state_change", function (res) {
          console.log('trigger', res);
          document.dispatchEvent(new CustomEvent('wxdownloader:state_change', { detail: res }));
        });
      }
    } else {
      callback(false);
    }
  });

  setTimeout(function () {
    callback(null, null);
  }, 6000);
};

/**
 * 根据localStorage数据确定使用新下载任务还是旧下载任务
 */
function build(native, callback) {
  var md5 = localStorage.getItem('m_video_download_md5');
  var confid = localStorage.getItem('m_video_download_confid');
  var download_id = localStorage.getItem('m_video_download_id');
  var progress = localStorage.getItem('m_video_download_progress');
  var time = Date.now() - localStorage.getItem('m_video_download_time');

  if (confid && download_id && time < 1296000000) {
    WeixinJSBridge.invoke("queryDownloadTask", {
      "download_id": download_id // 任务id，用于唯一标识一个下载任务
    }, function (res) {
      if (res.state == 'download_succ' || res.state == 'downloading') {
        callback(null, factory(native, {
          md5: md5 || '',
          confid: confid,
          download_id: download_id,
          progress: progress,

          local: true
        }));
      }
      else {
        callback(null, factory(native, {
          local: false
        }));
      }
    });
  } else {
    callback(null, factory(native, {
      local: false
    }));
  }
}

/**创建downloader实例对象
 *
 * @param native
 * @param cfg
 * @returns {wxProto}
 */
function factory(native, cfg) {
  var _model = {
    md5: cfg.md5,
    confid: cfg.confid,
    id: cfg.download_id,
    progress: cfg.progress || 0,
    url: ''
  };
  var descriptor = {
    native: {
      value: native
    },
    local: {
      value: cfg.local,
      writable: true
    }
  };
  Object.keys(_model).forEach(function (key) {
    descriptor[key] = {
      get: function () {
        return _model[key]
      },
      set: function (v) {
        _model[key] = v;
        localStorage.setItem('m_video_download_' + key, v);
        localStorage.setItem('m_video_download_time', Date.now());
      }
    };
    //进度特殊处理，触发native的进度事件，而且不重写time
    if (key == 'progress') {
      descriptor['progress'].set = function (v) {
        _model[key] = v;
        localStorage.setItem('m_video_download_' + key, v);
        native.emit('progress', v);
      }
    }
  });
  var obj = Object.create(wxProto, descriptor);
  var onStateChange = function (res) {
    res = res.data || res._args || res;
    try {
      window[native.package.playerDownloadCallback](res);
    } catch (e) { }
    console.log('wxdownloader:state_change', res);
    if (res.download_id == obj.id || res.download_id == '') {
      console.log(res.state, DOWNLOADER_STATE[res.state]);
      native.state = DOWNLOADER_STATE[res.state];
    }
  };
  if (native.package.wxDownloaderCallback) {
    window[native.package.wxDownloaderCallback] = onStateChange;
  } else {
    document.addEventListener('wxdownloader:state_change', function (e) {
      onStateChange.call(this, e.detail);
    });
  }
  return obj;
}

//wxdownloader原型。
var wxProto = {
  //开始下载
  start: function (cfg) {
    if (!cfg.url) {
      throw new Error('wx downloader:need downloadurl');
    }
    if (!cfg.confid) {
      console.warn('wx downloader:need confid');
    }
    if (!this.native.package.md5) {
      throw new Error('wx downloader:need md5 cgi');
    }
    var self = this;
    console.log('wxdownloader restart from local:' + this.local);
    //判断有无过往任务，有则使用上次配置并使用假续传。
    if (this.local) {
      start.call(this, this.native.package.name, this.url, this.md5);

    } else {
      if (this.native.package.hasmd5) {
        start.call(self, self.native.package.name, cfg.url, this.native.package.md5);
      } else {
        var confid = cfg.confid
        if (/mcgi\.v\.q\.com/.test(this.url) || /commdatav2/.test(this.url)) {
          var query = Url.queryParse((this.url || '').split('?')[1] || '')
          confid = query.cmd && /^\d+$/.test(query.confid) ? Number(query.confid) : ''
        }

        function downloadHandler(err, ret) {
          //console.log(ret);
          if (err) {
            function blurHandler() {
              clearTimeout(timer);
              removeBlurHandler();
            }
            function removeBlurHandler() {
              try {
                window.removeEventListener('blur', blurHandler);
              } catch (e) { }
            }
            window.addEventListener('blur', blurHandler);
            setTimeout(function () {
              removeBlurHandler();
            }, 3000);
            var timer = setTimeout(function () {
              removeBlurHandler();
              location.href = cfg.url;
            }, 2000);
            start.call(self, self.native.package.name, cfg.url, '');

          } else {
            start.call(self, self.native.package.name, cfg.url, ret.md5);
          }
        }
        if (cfg.verify === false) {
          // 如果给定了md5的值
          if (cfg.md5Value) {
            downloadHandler(null, { md5: cfg.md5Value })
          } else {
            downloadHandler(null, { md5: '' })
          }
        } else {
          checkMd5(this.native.package.md5(confid, this.url), downloadHandler);
        }
      }
    }
  },
  //暂停
  pause: function () {
    this.cancel.apply(this, arguments);
  },
  //取消
  cancel: function () {
    var self = this;
    WeixinJSBridge.invoke('cancelDownloadTask', {
      "download_id": this.id, // 任务id，用于唯一标识一个下载任务
      "file_md5": this.md5 || ''	// 安装包md5
    }, function (res) {
      if (res.err_msg.indexOf("cancel_download_task:ok") > -1) {
        console.log('wxdownloader cancel:', self.id, self.md5, res.err_msg);
        self.native.state = NATIVE_STATE.PAUSE;
      }
    });
  },
  //重新开始
  restart: function () {
    this.start.apply(this, arguments);
  },
  //安装
  install: function () {
    var self = this;
    WeixinJSBridge.invoke('installDownloadTask', {
      "download_id": this.id,
      "file_md5": this.md5 || ''
    }, function (res) {
      console.log(res);
      if (res.err_msg.indexOf("install_download_task:ok") > -1) {
        //self.native.downloadStateChange({"state": "installing"});
        self.native.state = NATIVE_STATE.INSTALLING;
      }
    });
  }
};

/**
 * 确定新下载任务的md5
 * @param url
 * @param callback
 */
function checkMd5(url, callback) {
  jsonp(url, function (err, json_msg) {
    if (err) callback(304);
    if (json_msg && json_msg.md5 && json_msg.md5 != "null") {
      //ajaxDefer.resolve(json_msg);
      callback(null, json_msg);
    }
    else {
      //ajaxDefer.reject(501);
      callback(501);
    }
  });
}
/**
 * 开始下载
 * @param name app名
 * @param url 下载url
 * @param md5 md5
 */
function start(name, url, md5) {
  var self = this;
  

  if (typeof self.native.package.app_version === 'function') {
    var appVersion = self.native.package.app_version();
    if (typeof appVersion === 'object') {
      appVersion.then(function(version) {
        invoke(version);
      })
    } else {
      invoke(appVersion);
    }
  } else {
    var appVersion = self.native.package.app_version;
    if (typeof appVersion === 'object') {
      appVersion.then(function(version){
        invoke(version);
      })
    } else {
      invoke(appVersion);
    }
  }

  function invoke(version) {
    WeixinJSBridge.invoke("addDownloadTask", {
      "task_name": name,	// 任务名称，用于通知栏显示
      "task_url": url,	// 安装包url
      "file_md5": md5 || '',	// 安装包md5
      "thumb_url": self.native.package.icon,
      "title": self.native.package.name,
      // 开发者
      "developer": self.native.package.developer || '',
      // 版本信息
      "app_version": version || '',
      // 隐私策略
      "privacy_agreement_url": self.native.package.privacy_agreement_url || '',
      // 权限详情
      "permission_url": self.native.package.permission_url || '',
    }, function (res) {
      console.log('wxdownloader start:' + res.download_id);
      var msg = res.err_msg;
      self.id = res.download_id;
      self.md5 = md5;
      self.url = url;
      self.local = true;//记录为有本地任务
      if (msg.indexOf("add_download_task:ok") > -1) {
        self.native.state = NATIVE_STATE.DOWNLOADING;
        //微信下进度条是假的，而且需要定时器去判断是否已安装成功。
  
        !self.timer && (self.timer = setInterval(function () {
          if (self.native.state == NATIVE_STATE.INSTALLING || self.native.state == NATIVE_STATE.DOWNLOADED) {
            setTimeout(function () {
              WeixinJSBridge.invoke('getInstallState', {
                'packageName': self.native.package.pkg,
                'packageUrl': self.native.package.pkgurl
              }, function (e) {
                var msg = e.err_msg;
                if (msg.indexOf("yes") > -1) {
                  self.native.state = NATIVE_STATE.INSTALLED
                }
              });
            }, 50);
          } else if (self.native.state == NATIVE_STATE.DOWNLOADING) {
            //console.log('wxdownloader: progress ++');
            //假进度 最多跑到90吧
            self.progress = Math.min(90, self.progress + 1);
          }
        }, 150));
  
      } else if (msg.indexOf("add_download_task:cancel") > -1) {
        self.native.state = NATIVE_STATE.CANCEL;
      }
    });
  }
}
